import * as Sentry from "@sentry/react";

// Callers pass whatever they caught: an Error, or the raw API response thrown by
// processResponseWithApiProblemDetails. Nothing here may assume an Error shape.
export const logError = (
  error?: unknown,
  additionalInfo?: unknown,
  isUserDialogShown = true,
) => {
  console.log("ErrorService logError", error, additionalInfo);

  if (error || additionalInfo) {
    Sentry.captureException(error ?? additionalInfo, {
      extra: {
        doNotShowDialog: !isUserDialogShown,
      },
    });
  }
};
